import React, { useEffect, useState } from "react";
import { colors } from "../../../../../theme/colors";
import { MdReplay } from "react-icons/md";
import { Box, Flex } from "rebass/styled-components";
import styled from "styled-components";
import { Button, Link } from "../../../../Components/Button";
import { Body, Subheader } from "../../../../Components/Text";
import { RiCheckboxCircleFill } from "react-icons/ri";
import { FaPlay } from "react-icons/fa";
import { IoIosNotifications } from "react-icons/io";
import { MdLaunch } from "react-icons/md";
import theme from "../../../../../theme/themeThree";
import {
  OverlayEditTitle,
  OverlayRemix,
  OverlayShare,
  OverlayDownload,
  OverlayMobile,
  OverlayInfo,
  OverlaySettings,
} from "../../../../Components/Button/PlayerOverlay";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {
  PartnerViewSession,
  IsUserLoggedIn,
  OverlayTriggerState,
} from "../../../../State";
import { useWindowSize } from "../../../../Hooks/useWindowSize";
import { SharePopout } from "../SharePopout";
import { AiOutlineStar } from "react-icons/ai";
import { AttemptedAction } from "../AttemptedAction";
import { isFaceItPartner } from "../../Utilities";
import { useStatsigClient } from "@statsig/react-bindings";
import { analytics } from "MVVM/Analytics";
import { useAnalyticsContext } from "MVVM/Hooks/useAnalyticsContext";

export function PartnerOverlay({
  onReplayClick,
  display,
  translateHook,
  platform,
  overlayTrigger,
  player,
}: any) {
  const [partnerViewSession] = useRecoilState(PartnerViewSession);
  const isLoggedIn = useRecoilValue(IsUserLoggedIn);
  const setOverlayTrigger = useSetRecoilState(OverlayTriggerState);
  const { overlayConfig, dynamicCta } = partnerViewSession;
  const size = useWindowSize();
  const [ctaSize, setCtaSize] = useState("default");
  const [shouldShowOverlay, setShouldShowOverlay] = useState(
    display && overlayConfig.display,
  );
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [displaySharePopout, setDisplaySharePopout] = useState(false);
  const [attemptedAction, setAttemptedAction] = useState("");
  const shouldShowCta = dynamicCta?.mainCopy;
  const isFaceItPartnerFlag = isFaceItPartner(platform);
  const { getExperiment } = useStatsigClient();
  const renderNotificationBanner = getExperiment(
    "iframe_notification_banner",
  ).get("show_notification_banner", false);
  const analyticsContext = useAnalyticsContext(platform);

  useEffect(() => {
    if (shouldShowOverlay) {
      analytics.track("Overlay - Display", {
        isLoggedIn: isLoggedIn,
        knownUser: overlayConfig?.knownUser,
        shareId: overlayConfig?.shareId,
        link: partnerViewSession?.dynamicCta?.link,
        type: partnerViewSession?.dynamicCta?.type,
        isClaimable: partnerViewSession.dynamicCta.isClaimable,
        ...analyticsContext,
      });
      if (
        partnerViewSession?.promotion?.display &&
        partnerViewSession?.promotion?.name
      ) {
        analytics.track("Promotion - Impression", {
          promotionName: partnerViewSession?.promotion?.name,
          type: "videoPlayer",
          ...analyticsContext,
        });
      }
      // need to add promo impression here
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldShowOverlay]);

  useEffect(() => {
    setShouldShowOverlay(display && overlayConfig.display);
  }, [overlayConfig, display]);

  useEffect(() => {
    if (size.width && size.width <= 700 && ctaSize !== "tiny") {
      setCtaSize("tiny");
    }
    if (size.width && size.width > 700 && ctaSize !== "default") {
      setCtaSize("default");
    }
  }, [size, ctaSize]);

  const closeOthers = () => {
    setSettingsOpen(false);
    setDisplaySharePopout(false);
  };

  const getSettings = () => {
    switch (overlayConfig.resconfig) {
      case "1":
        return (
          <>
            <SettingsRow isActive={true}>
              <StyledCheckIcon />
              <StyledSettingsText pl={2}>
                720P30 (Current Resolution)
              </StyledSettingsText>
            </SettingsRow>
            <SettingsRow
              onClick={() => {
                try {
                  analytics.track("Overlay - Quality Click", {
                    knownUser: overlayConfig?.knownUser,
                    shareId: overlayConfig?.shareId,
                    type: "Desktop 1080P60 (16:9)",
                    ...analyticsContext,
                  });
                } catch (e) {}
                if (overlayConfig.knownUser)
                  window.open(overlayConfig.quality.remixLink, "_blank");
                else setAttemptedAction("adjustQuality");
              }}
            >
              <StyledStar />
              <StyledSettingsText pl={2}>
                Desktop 1080P60 (16:9)
              </StyledSettingsText>
            </SettingsRow>
            <SettingsRow
              onClick={() => {
                try {
                  analytics.track("Overlay - Quality Click", {
                    knownUser: overlayConfig?.knownUser,
                    shareId: overlayConfig?.shareId,
                    type: "Mobile 1080P60 (9:16)",
                    ...analyticsContext,
                  });
                } catch (e) {}
                if (overlayConfig.knownUser)
                  window.open(overlayConfig.quality.mobileLink, "_blank");
                else setAttemptedAction("adjustQuality");
              }}
            >
              <StyledStar />
              <StyledSettingsText pl={2}>
                Mobile 1080P60 (9:16)
              </StyledSettingsText>
            </SettingsRow>
          </>
        );
      case "2":
        return (
          <>
            <SettingsRow isActive={true}>
              <StyledCheckIcon />
              <StyledSettingsText pl={2}>
                Desktop 1080P60 (16:9)
              </StyledSettingsText>
            </SettingsRow>
            <SettingsRow
              onClick={() => {
                try {
                  analytics.track("Overlay - Quality Click", {
                    knownUser: overlayConfig?.knownUser,
                    shareId: overlayConfig?.shareId,
                    type: "Mobile 1080P60 (9:16)",
                    ...analyticsContext,
                  });
                } catch (e) {}
                if (overlayConfig.knownUser)
                  window.open(overlayConfig.mobile.link, "_blank");
                else setAttemptedAction("adjustQuality");
              }}
            >
              <StyledStar />
              <StyledSettingsText pl={2}>
                Mobile 1080P60 (9:16)
              </StyledSettingsText>
            </SettingsRow>
          </>
        );
      default:
        return <></>;
    }
  };

  return (
    <>
      <AttemptedAction
        translateHook={translateHook}
        overlayConfig={overlayConfig}
        type={attemptedAction}
        setAttemptedAction={setAttemptedAction}
        platform={platform}
      />
      <Box
        className="hover-controls"
        style={{
          display: shouldShowOverlay ? "none" : "block",
          width: "100%",
          pointerEvents: "none",
        }}
      >
        <Flex style={{ justifyContent: "space-between", marginTop: "30px" }}>
          <LeftSideButtonContainer>
            <InfoPosition>
              <DefaultBorder sx={{ ...theme.borders["overlayDefault"] }}>
                <StyledInfo
                  classification={"overlayDefault"}
                  size={"overlayOption"}
                  onClick={() => {
                    closeOthers();
                    setAttemptedAction("info");
                    setOverlayTrigger("hover");
                    try {
                      analytics.track("Overlay - Info Click", {
                        isLoggedIn: isLoggedIn,
                        knownUser: overlayConfig.knownUser,
                        shareId: overlayConfig.shareId,
                        ...analyticsContext,
                      });
                    } catch (e) {
                      console.log(e);
                    }
                  }}
                ></StyledInfo>
              </DefaultBorder>
            </InfoPosition>
            <SettingsButtonPosition>
              <DefaultBorder sx={{ ...theme.borders["overlayDefault"] }}>
                <StyledSettings
                  classification={"overlayDefault"}
                  size={"overlayOption"}
                  onClick={() => {
                    try {
                      if (!overlayConfig.knownUser) {
                        closeOthers();
                        setAttemptedAction("adjustQuality");
                      } else {
                        setAttemptedAction("thirdPartySettings");
                      }
                      setOverlayTrigger("hover");
                      analytics.track("Overlay - Settings Click", {
                        isLoggedIn: isLoggedIn,
                        knownUser: overlayConfig.knownUser,
                        shareId: overlayConfig.shareId,
                        ...analyticsContext,
                      });
                    } catch (e) {
                      console.log(e);
                    }
                  }}
                >
                  {!renderNotificationBanner && <Notification />}
                </StyledSettings>
              </DefaultBorder>
            </SettingsButtonPosition>
            {settingsOpen && (
              <SettingsContainerPosition>
                {overlayConfig.resconfig && <> {getSettings()}</>}
              </SettingsContainerPosition>
            )}
          </LeftSideButtonContainer>
          {renderNotificationBanner && (
            <StyledOptions>
              <StyledButtonWrapper>
                <Box style={{ height: "52px" }}>
                  <DefaultBorder
                    sx={{ ...theme.borders["overlayDefault"] }}
                    style={{
                      position: "relative",
                      height: "40px",
                      marginTop: "3px",
                      marginBottom: "6px",
                    }}
                  >
                    <NotificationContainer
                      onClick={() => player.pause()}
                      style={{ height: "44px" }}
                    >
                      <StyledNotificationBell />
                      <NotificationDot style={{ top: "9px" }} />
                    </NotificationContainer>
                  </DefaultBorder>
                </Box>
                <Box style={{ position: "relative" }}>
                  <DefaultBorder sx={{ ...theme.borders["overlayDefault"] }}>
                    <StyledShare
                      classification={"overlayDefault"}
                      size={"overlayOption"}
                      href={overlayConfig.share.link}
                      onClick={() => {
                        setDisplaySharePopout(!displaySharePopout);
                        try {
                          analytics.track("Overlay - Share Click", {
                            isLoggedIn: isLoggedIn,
                            shareId: overlayConfig.shareId,
                            ...analyticsContext,
                          });
                        } catch (e) {
                          console.log(e);
                        }
                      }}
                    />
                  </DefaultBorder>
                  <SharePopout
                    overlayConfig={overlayConfig}
                    display={displaySharePopout}
                    setDisplaySharePopout={setDisplaySharePopout}
                    setAttemptedAction={setAttemptedAction}
                  />
                </Box>
                <DefaultBorder sx={{ ...theme.borders["overlayDefault"] }}>
                  <StyledDownload
                    classification={"overlayDefault"}
                    size={"overlayOption"}
                    href={overlayConfig.edit.link}
                    onClick={() => {
                      closeOthers();

                      try {
                        analytics.track("Overlay - Download Click", {
                          isLoggedIn: isLoggedIn,
                          knownUser: overlayConfig.knownUser,
                          shareId: overlayConfig.shareId,
                          directDownload: isFaceItPartnerFlag,
                          ...analyticsContext,
                        });
                      } catch (e) {
                        console.log(e);
                      }

                      if (isFaceItPartnerFlag) {
                        return window.open(
                          `${process.env.REACT_APP_S3_CLIP_BUCKET}/${partnerViewSession?.clip?.clipLink}`,
                        );
                      }

                      if (!overlayConfig.knownUser) {
                        setAttemptedAction("download");
                      } else {
                        window.open(overlayConfig.download.link, "_blank");
                      }
                    }}
                  ></StyledDownload>
                </DefaultBorder>
                <DefaultBorder sx={{ ...theme.borders["overlayDefault"] }}>
                  <StyledMobile
                    classification={"overlayDefault"}
                    size={"overlayOption"}
                    href={overlayConfig.edit.link}
                    onClick={() => {
                      closeOthers();
                      if (!overlayConfig.knownUser) {
                        setAttemptedAction("mobile");
                      } else {
                        window.open(overlayConfig.mobile.link, "_blank");
                      }

                      try {
                        analytics.track("Overlay - Mobile Click", {
                          isLoggedIn: isLoggedIn,
                          knownUser: overlayConfig.knownUser,
                          shareId: overlayConfig.shareId,
                          ...analyticsContext,
                        });
                      } catch (e) {
                        console.log(e);
                      }
                    }}
                  ></StyledMobile>
                </DefaultBorder>
                <DefaultBorder sx={{ ...theme.borders["overlayDefault"] }}>
                  <StyledRemix
                    classification={"overlayDefault"}
                    size={"overlayRemixOption"}
                    onClick={() => {
                      try {
                        closeOthers();
                        if (!overlayConfig.knownUser) {
                          setAttemptedAction("addfx");
                        } else {
                          window.open(overlayConfig.remix.link, "_blank");
                        }
                        analytics.track("Overlay - Remix Click", {
                          isLoggedIn: isLoggedIn,
                          knownUser: overlayConfig.knownUser,
                          shareId: overlayConfig.shareId,
                          ...analyticsContext,
                        });
                      } catch (e) {
                        console.log(e);
                      }
                    }}
                  ></StyledRemix>
                </DefaultBorder>{" "}
                {!isFaceItPartnerFlag && (
                  <DefaultBorder sx={{ ...theme.borders["overlayDefault"] }}>
                    <StyledEditTitle
                      classification={"overlayDefault"}
                      size={"overlayOption"}
                      onClick={() => {
                        closeOthers();

                        if (!overlayConfig.knownUser) {
                          setAttemptedAction("editTitle");
                        } else {
                          window.open(overlayConfig.edit.link, "_blank");
                        }
                        try {
                          analytics.track("Overlay - Edit Click", {
                            isLoggedIn: isLoggedIn,
                            knownUser: overlayConfig.knownUser,
                            shareId: overlayConfig.shareId,
                            ...analyticsContext,
                          });
                        } catch (e) {
                          console.log(e);
                        }
                      }}
                    ></StyledEditTitle>
                  </DefaultBorder>
                )}
              </StyledButtonWrapper>
            </StyledOptions>
          )}
        </Flex>
      </Box>
      <ClipOverlay
        className="videoOverlay"
        display={shouldShowOverlay ? "block" : "none"}
        $overlayTrigger={overlayTrigger}
      >
        <Flex style={{ justifyContent: "space-between", marginTop: "30px" }}>
          <LeftSideButtonContainer>
            <InfoPosition>
              <DefaultBorder sx={{ ...theme.borders["overlayDefault"] }}>
                <StyledInfo
                  classification={"overlayDefault"}
                  size={"overlayOption"}
                  onClick={() => {
                    closeOthers();
                    setAttemptedAction("info");
                    try {
                      analytics.track("Overlay - Info Click", {
                        isLoggedIn: isLoggedIn,
                        knownUser: overlayConfig.knownUser,
                        shareId: overlayConfig.shareId,
                        ...analyticsContext,
                      });
                    } catch (e) {
                      console.log(e);
                    }
                  }}
                ></StyledInfo>
              </DefaultBorder>
            </InfoPosition>
            {!isFaceItPartnerFlag && (
              <SettingsButtonPosition>
                <DefaultBorder sx={{ ...theme.borders["overlayDefault"] }}>
                  <StyledSettings
                    classification={"overlayDefault"}
                    size={"overlayOption"}
                    onClick={() => {
                      try {
                        if (!overlayConfig.knownUser) {
                          closeOthers();
                          setAttemptedAction("adjustQuality");
                        } else {
                          setAttemptedAction("thirdPartySettings");
                        }
                        analytics.track("Overlay - Settings Click", {
                          isLoggedIn: isLoggedIn,
                          knownUser: overlayConfig.knownUser,
                          shareId: overlayConfig.shareId,
                          ...analyticsContext,
                        });
                      } catch (e) {
                        console.log(e);
                      }
                    }}
                  >
                    {!renderNotificationBanner && <Notification />}
                  </StyledSettings>
                </DefaultBorder>
              </SettingsButtonPosition>
            )}
            {settingsOpen && (
              <SettingsContainerPosition>
                {overlayConfig.resconfig && <> {getSettings()}</>}
              </SettingsContainerPosition>
            )}
          </LeftSideButtonContainer>
          <StyledOptions>
            {renderNotificationBanner && overlayTrigger !== "preplay" && (
              <NotificationBanner
                link={partnerViewSession?.notificationBanner?.link}
                thumbnail={partnerViewSession?.notificationBanner?.thumbnail}
                text={partnerViewSession?.notificationBanner?.text}
                buttonText={partnerViewSession?.notificationBanner?.buttonText}
                platform={platform}
              />
            )}
            <StyledButtonWrapper>
              <Box style={{ position: "relative" }}>
                <DefaultBorder sx={{ ...theme.borders["overlayDefault"] }}>
                  <StyledShare
                    classification={"overlayDefault"}
                    size={"overlayOption"}
                    href={overlayConfig.share.link}
                    onClick={() => {
                      setDisplaySharePopout(!displaySharePopout);
                      try {
                        analytics.track("Overlay - Share Click", {
                          isLoggedIn: isLoggedIn,
                          shareId: overlayConfig.shareId,
                          ...analyticsContext,
                        });
                      } catch (e) {
                        console.log(e);
                      }
                    }}
                  />
                </DefaultBorder>
                <SharePopout
                  overlayConfig={overlayConfig}
                  display={displaySharePopout}
                  setDisplaySharePopout={setDisplaySharePopout}
                  setAttemptedAction={setAttemptedAction}
                />
              </Box>
              <DefaultBorder sx={{ ...theme.borders["overlayDefault"] }}>
                <StyledDownload
                  classification={"overlayDefault"}
                  size={"overlayOption"}
                  href={overlayConfig.edit.link}
                  onClick={() => {
                    closeOthers();

                    try {
                      analytics.track("Overlay - Download Click", {
                        isLoggedIn: isLoggedIn,
                        knownUser: overlayConfig.knownUser,
                        shareId: overlayConfig.shareId,
                        directDownload: isFaceItPartnerFlag,
                        ...analyticsContext,
                      });
                    } catch (e) {
                      console.log(e);
                    }

                    if (isFaceItPartnerFlag) {
                      return window.open(
                        `${process.env.REACT_APP_S3_CLIP_BUCKET}/${partnerViewSession?.clip?.clipLink}`,
                      );
                    }

                    if (!overlayConfig.knownUser) {
                      setAttemptedAction("download");
                    } else {
                      window.open(overlayConfig.download.link, "_blank");
                    }
                  }}
                ></StyledDownload>
              </DefaultBorder>
              <DefaultBorder sx={{ ...theme.borders["overlayDefault"] }}>
                <StyledMobile
                  classification={"overlayDefault"}
                  size={"overlayOption"}
                  href={overlayConfig.edit.link}
                  onClick={() => {
                    closeOthers();
                    if (!overlayConfig.knownUser) {
                      setAttemptedAction("mobile");
                    } else {
                      window.open(overlayConfig.mobile.link, "_blank");
                    }

                    try {
                      analytics.track("Overlay - Mobile Click", {
                        isLoggedIn: isLoggedIn,
                        knownUser: overlayConfig.knownUser,
                        shareId: overlayConfig.shareId,
                        ...analyticsContext,
                      });
                    } catch (e) {
                      console.log(e);
                    }
                  }}
                ></StyledMobile>
              </DefaultBorder>
              <DefaultBorder sx={{ ...theme.borders["overlayDefault"] }}>
                <StyledRemix
                  classification={"overlayDefault"}
                  size={"overlayRemixOption"}
                  onClick={() => {
                    try {
                      closeOthers();
                      if (!overlayConfig.knownUser) {
                        setAttemptedAction("addfx");
                      } else {
                        window.open(overlayConfig.remix.link, "_blank");
                      }
                      analytics.track("Overlay - Remix Click", {
                        isLoggedIn: isLoggedIn,
                        knownUser: overlayConfig.knownUser,
                        shareId: overlayConfig.shareId,
                        ...analyticsContext,
                      });
                    } catch (e) {
                      console.log(e);
                    }
                  }}
                ></StyledRemix>
              </DefaultBorder>{" "}
              {!isFaceItPartnerFlag && (
                <DefaultBorder sx={{ ...theme.borders["overlayDefault"] }}>
                  <StyledEditTitle
                    classification={"overlayDefault"}
                    size={"overlayOption"}
                    onClick={() => {
                      closeOthers();

                      if (!overlayConfig.knownUser) {
                        setAttemptedAction("editTitle");
                      } else {
                        window.open(overlayConfig.edit.link, "_blank");
                      }
                      try {
                        analytics.track("Overlay - Edit Click", {
                          isLoggedIn: isLoggedIn,
                          knownUser: overlayConfig.knownUser,
                          shareId: overlayConfig.shareId,
                          ...analyticsContext,
                        });
                      } catch (e) {
                        console.log(e);
                      }
                    }}
                  ></StyledEditTitle>
                </DefaultBorder>
              )}
            </StyledButtonWrapper>
          </StyledOptions>
        </Flex>
        {overlayTrigger !== "preplay" && (
          <StyledReplayWrapper>
            <StyledButton flex={true} classification={"bigReplay"}>
              <MdReplay
                size={40}
                onClick={() => {
                  try {
                    analytics.track("Overlay - Replay Click", {
                      isLoggedIn: isLoggedIn,
                      knownUser: overlayConfig.knownUser,
                      shareId: overlayConfig.shareId,
                      ...analyticsContext,
                    });
                  } catch (e) {
                    console.log(e);
                  }
                  onReplayClick();
                }}
              />
            </StyledButton>
          </StyledReplayWrapper>
        )}
        {!renderNotificationBanner && (
          <StyledCta flexDirection={"column"} shouldShowCta={shouldShowCta}>
            {overlayConfig.centerText.show && (
              <IndependentTextWrapper>
                <StyledHeadline>{dynamicCta.mainCopy}</StyledHeadline>
              </IndependentTextWrapper>
            )}
            <CtaButton
              flex={true}
              size={ctaSize}
              px={4}
              onClick={() => {
                try {
                  analytics.track("Overlay - Center Main Button Click", {
                    isLoggedIn: isLoggedIn,
                    knownUser: overlayConfig.knownUser,
                    shareId: overlayConfig.shareId,
                    link: partnerViewSession.dynamicCta.link,
                    type: partnerViewSession.dynamicCta.type,
                    isClaimable: partnerViewSession.dynamicCta.isClaimable,
                    ...analyticsContext,
                  });

                  if (partnerViewSession?.promotion?.display) {
                    analytics.track("Promotion - Button Click", {
                      isLoggedIn: isLoggedIn,
                      knownUser: overlayConfig.knownUser,
                      link: partnerViewSession.dynamicCta.link,
                      type: "videoPlayer",
                      ...analyticsContext,
                    });
                  }

                  try {
                    window.open(
                      `${partnerViewSession.dynamicCta.link}`,
                      "_blank",
                    );
                  } catch (e) {
                    analytics.track("Overlay - Center Main Button Click Fail", {
                      error: `${e}`,
                      ...analyticsContext,
                    });
                  }
                } catch (e) {}
              }}
            >
              {partnerViewSession.dynamicCta.buttonText}
            </CtaButton>
          </StyledCta>
        )}
      </ClipOverlay>
    </>
  );
}

const Notification = styled.span`
  position: absolute;
  top: 0px;
  right: -5px;
  padding: 6px;
  border-radius: 50%;
  background: red;
  color: white;
`;

const IndependentTextWrapper = styled(Flex)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  padding-left: 50px;
  justify-content: center;
  align-items: center;
  padding-left: 20px;
  padding-right: 20px;
  @media (max-width: 700px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  @media (max-width: 300px) {
    display: none;
  }
  @media (max-height: 330px) {
    display: none;
  }
`;

const StyledStar = styled<any>(AiOutlineStar)`
  transition: color 0.1s;
`;

const ClipOverlay = styled(Flex)<{ $overlayTrigger: string }>`
  position: absolute;
  pointer-events: none;
  background: ${(props) =>
    props.$overlayTrigger === "preplay"
      ? "transparent"
      : colors.midnightAlpha80};
  top: 0;
  left: 0;
  display: ${(props) => {
    return props.display;
  }};

  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  z-index: 2;
  transition:
    opacity 0.2s,
    visibility 0s 0.2s;
`;

const StyledCheckIcon = styled(RiCheckboxCircleFill)`
  color: ${(props) => props.theme.colors.envy};
  width: 16px;
  height: 16px;
`;

const CtaButton = styled(Button)`
  pointer-events: auto;
  border-radius: 999px;
  position: absolute;
  top: -45%;
  @media (max-width: 700px) {
    top: -18%;
  }
  @media (max-height: 330px) {
    top: -50%;
  }
`;

const StyledCta = styled<any>(Flex)`
  position: absolute;
  pointer-events: auto;
  bottom: 3%;
  left: 2%;
  right: 2%;
  border-radius: 10px;
  height: 90px;
  align-items: center;
  justify-content: center;
  background: ${colors.envyAlpha10};
  border: 2px solid ${colors.envyAlpha50};
  @media (max-width: 800px) {
    height: 90px;
  }
  @media (max-width: 700px) {
    height: 100px;
  }
  @media (max-width: 300px) {
    height: 40px;
    border: 0px solid ${colors.envy};
    bottom: 0%;
    left: 0%;
    right: 0%;
    border-radius: 0px;
  }
  @media (max-height: 330px) {
    height: 40px;
    border: 0px solid ${colors.envy};
    bottom: 0%;
    left: 0%;
    right: 0%;
    border-radius: 0px;
  }
  visibility: ${(props: any) => {
    if (props.shouldShowCta) {
      return "visible";
    } else {
      return "hidden";
    }
  }};
`;

const StyledShare = styled(OverlayShare)`
  height: 55px;
  width: 55px;
  padding-top: 0px;
  @media (max-width: 700px) {
    padding-top: 6px;
  }
`;
const StyledDownload = styled(OverlayDownload)`
  height: 55px;
  width: 55px;
  padding-top: 0px;
  @media (max-width: 700px) {
    padding-top: 6px;
  }
`;

const StyledMobile = styled(OverlayMobile)``;
const StyledSettingsText = styled(Subheader)`
  transition: color 0.1s;
  &:hover {
    color: ${colors.envy};
  }
`;
const StyledSettings = styled(OverlaySettings)`
  height: 55px;
  width: 55px;
  padding-top: 0px;
  line-height: 37px !important;
  z-index: 100;
`;
const StyledRemix = styled(OverlayRemix)``;
const DefaultBorder = styled(Box)``;

const StyledButtonWrapper = styled(Flex)`
  width: 46px;
  flex-direction: column;
  gap: 15px;
  flex-shrink: 0;
  pointer-events: auto;

  @media (max-width: 650px) {
    width: 33px;
    gap: 8px;
  }
`;

const StyledEditTitle = styled(OverlayEditTitle)`
  height: 55px;
  width: 55px;
  padding-top: 0px;
  line-height: 37px !important;
`;

const StyledInfo = styled(OverlayInfo)`
  height: 55px;
  width: 55px;
  padding-top: 0px;
  line-height: 37px !important;
  z-index: 100;
`;
const SettingsButtonPosition = styled(Box)`
  pointer-events: auto;
  flex-direction: column;
`;
const SettingsRow = styled<any>(Flex)`
  width: 100%;
  align-items: center;
  padding-left: 5px;
  border-left: 2px solid transparent;
  pointer-events: auto;

  ${(props) => {
    if (props.isActive) {
      return `
        border-left: 2px solid ${colors.envy};
        color: ${colors.envy};
      `;
    } else {
      return `
        &:hover {
          color: ${colors.envy};
          cursor:pointer;
        }
      `;
    }
  }}
`;

const InfoPosition = styled(Box)`
  pointer-events: auto;
  flex-direction: column;
`;
const SettingsContainerPosition = styled(Flex)`
  pointer-events: auto;
  background: ${colors.midnightAlpha70};
  flex-direction: column;
  justify-content: end;
  align-items: end;
  position: absolute;
  width: 230px;
  gap: 10px;
  left: 10px;
  top: 10px;
  z-index: 9;
  border-radius: 9px;
  padding-right: 15px;
  padding-left: 15px;
  padding-bottom: 15px;

  padding-top: 70px;
  @media (max-width: 700px) {
    left: 0px;
    top: 50px;
    padding-top: 15px;
    background: ${colors.midnightAlpha90};
  }
`;

const LeftSideButtonContainer = styled(Flex)`
  flex-direction: column;
  gap: 15px;
  margin-left: 20px;

  @media (max-width: 425px) {
    margin-left: 10px;
  }
`;

const StyledOptions = styled(Flex)`
  flex-direction: column;
  gap: 15px;
  z-index: 100;
  align-items: end;
  margin-right: 20px;
  @media (max-width: 650px) {
    gap: 8px;
  }

  @media (max-width: 425px) {
    margin-right: 10px;
  }
`;
const StyledButton = styled(Button)``;
const StyledHeadline = styled(Body)`
  max-width: 90%;
  text-align: center;
  font-weight: 600;
  font-size: 1.2em;
  @media (max-width: 900px) {
    max-width: 100%;
    font-size: 1em;
    font-weight: 500;
  }
  @media (max-width: 700px) {
    max-width: 90%;
    font-size: 0.8em;
    font-weight: 400;
  }
`;
const StyledReplayWrapper = styled(Flex)`
  pointer-events: auto;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

const Wrapper = styled(Box)<{ $hasThumbnail: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${(props) => (props.$hasThumbnail ? "0 0 0 9rem" : "0")};
  border-radius: 9999px;
  backdrop-filter: blur(4px);
  background-color: transparent;
  transform: translateX(70%);
  transition:
    transform 0.7s ease-in-out,
    background-color 0.1s;
  opacity: 1;
  position: relative;
  width: auto;
  height: 52px;

  &.reveal {
    transform: translateX(0);
    background-color: ${({ theme }) => theme.colors.darkerNed};
  }

  &.hide {
    transform: translateX(0%);
    opacity: 1;
    background-color: transparent;
  }

  @media (max-width: 768px) {
    padding: ${(props) => (props.$hasThumbnail ? "0 0 0 7rem" : "0")};
  }

  @media (max-width: 650px) {
    padding: ${(props) => (props.$hasThumbnail ? "0 0 0 6rem" : "0")};
  }

  @media (max-width: 425px) {
    height: 37px;
  }
`;

const ThumbnailWrapper = styled(Box)`
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);

  @media (min-width: 640px) {
    transform: translateY(-50%) translateX(0);
  }

  &.hide {
    opacity: 0;
    transition: opacity: 0.5s ease;
  }
`;

const Thumbnail = styled.img`
  width: 128px;
  height: 80px;
  flex-shrink: 0;
  border-radius: 0.5rem;
  border: ${({ theme }) => `2px solid ${theme.colors.envy};`}
  box-shadow: ${({ theme }) =>
    `0 0 #0000, 0 0 #0000, ${theme.colors.envyAlpha30} 0px 0px 16px 0px`};

  @media (max-width: 768px) {
    width: 100px;
    height: 70px;
  }

  @media (max-width: 650px) {
    width: 90px;
    height: 60px;
  }

  @media (max-width: 425px) {
    width: 80px;
    height: 50px;
  }
`;

const ThumbnailBackground = styled(Box)`
  position: absolute;
  top: 0;
  width: 128px;
  height: 80px;
  aspect-ratio: 16 / 9;
  flex-shrink: 0;
  border-radius: 0.5rem;
  border: ${({ theme }) => `2px solid ${theme.colors.envy};`}
  box-shadow: ${({ theme }) =>
    `0 0 #0000, 0 0 #0000, ${theme.colors.envyAlpha30} 0px 0px 16px 0px`};
  background-color: ${({ theme }) => theme.colors.ned};
  transform: rotate(-6deg);
  z-index: -50;

  @media (max-width: 768px) {
    width: 100px;
    height: 70px;
  }

  @media (max-width: 650px) {
    width: 90px;
    height: 60px;
  }

  @media (max-width: 425px) {
    width: 80px;
    height: 50px;
  }
`;

const Text = styled.p`
  color: ${({ theme }) => theme.colors.ice};
  font-size: 16px;
  line-height: 20px;
  font-weight: 500;

  span {
    font-weight: bold;
    color: ${({ theme }) => theme.colors.envy};
  }

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 16px;
  }

  @media (max-width: 650px) {
    font-size: 13px;
    line-height: 16px;
  }

  @media (max-width: 425px) {
    margin-top: 2px;
    margin-bottom: 2px;
    font-size: 10px;
    line-height: 12px;
  }
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  cursor: pointer;

  &.hide {
    display: none;
  }
`;

const StyledCtaButton = styled(Flex)`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  margin-right: 15px;
  background-color: ${({ theme }) => theme.colors.envy};
  border-radius: 100px;
  justify-content: center;
  padding: 5px 15px;

  span {
    font-weight: 500;
    color: ${({ theme }) => theme.colors.ice};
    white-space: nowrap;
    font-size: 16px;
    line-height: 20px;
  }

  svg {
    width: 0.75rem;
    height: 0.75rem;
    color: ${({ theme }) => theme.colors.ice};
    display: none;

    @media (min-width: 768px) {
      display: inline-block;
      width: 1rem;
      height: 1rem;
    }
  }

  @media (max-width: 650px) {
    margin-right: 8px;

    span {
      font-size: 14px;
      line-height: 18px;
    }
  }

  @media (max-width: 425px) {
    padding: 5px 20px;
  }
`;

const SlidingContent = styled(Box)<{ $hasThumbnail: boolean }>`
  transform: translateX(3rem);
  opacity: 0;
  transition:
    transform 0.5s ease,
    opacity 0.5s ease;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  background-color: ${({ theme }) => theme.colors.darkerNed};
  margin-left: ${(props) => (props.$hasThumbnail ? "1rem" : "1.5rem")};

  &.reveal {
    transform: translateX(0);
    opacity: 1;
  }

  &.hide {
    opacity: 0;
    transform: translateX(3rem);
  }

  @media (max-width: 650px) {
    gap: 5px;
    margin-left: ${(props) => (props.$hasThumbnail ? "0" : "1rem")};
  }
`;

const StyledPlayButton = styled(FaPlay)`
  height: 20px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 20px;
  color: ${({ theme }) => theme.colors.ice};
`;

const StyledNotificationBell = styled(IoIosNotifications)`
  height: 20px;
  width: 20px;
  color: ${({ theme }) => theme.colors.ice};
`;

const NotificationContainer = styled(Flex)`
  cursor: pointer;
  border-radius: 100px;
  height: 40px;
  width: 40px;
  padding: 5px;
  background-color: ${({ theme }) => theme.colors.darkerNed};
  justify-content: center;
  align-items: center;

  &.hide {
    border-top-left-radius: 100px;
    border-bottom-left-radius: 100px;
  }

  :hover {
    background-color: ${({ theme }) => theme.colors.envy};
  }

  @media (max-width: 650px) {
    height: 33px;
    width: 33px;
  }
`;

const NotificationDot = styled.span`
  position: absolute;
  top: 12px;
  right: 12px;
  padding: 4px;
  border-radius: 50%;
  background: red;

  @media (max-width: 650px) {
    top: 7px;
    right: 5px;
    padding: 3px;
  }
`;

const NotificationBanner = ({
  link,
  thumbnail,
  text,
  buttonText,
  platform,
}: {
  link: string;
  thumbnail: string;
  text: React.ReactNode;
  buttonText: string;
  platform: string;
}) => {
  const [reveal, setReveal] = useState(false);
  const [hide, setHide] = useState(false);
  const analyticsContext = useAnalyticsContext(platform);

  useEffect(() => {
    const timer = setTimeout(() => setReveal(true), 500);
    return () => clearTimeout(timer);
  }, []);

  const togglePanel = () => {
    setHide((prev) => !prev);
    setReveal((prev) => !prev);
    try {
      analytics.track("Notification Button - Toggle Banner", {
        ...analyticsContext,
      });
    } catch (e) {
      console.log(e);
    }
  };

  const trackLinkClick = () => {
    try {
      analytics.track("Notification Button - Click Link", {
        ...analyticsContext,
      });
    } catch (e) {
      console.log(e);
    }
  };

  const wrapperClass = `${reveal ? "reveal" : ""} ${hide ? "hide" : ""}`;
  const contentClass = `${reveal ? "reveal" : ""} ${hide ? "hide" : ""}`;

  return (
    <Box style={{ pointerEvents: "auto" }}>
      <Wrapper className={wrapperClass} $hasThumbnail={!!thumbnail}>
        <StyledLink
          href={link}
          target="_blank"
          onClick={trackLinkClick}
          className={hide ? "hide" : ""}
        >
          {!!thumbnail && (
            <ThumbnailWrapper className={hide ? "hide" : ""}>
              <Thumbnail
                src={`${process.env.REACT_APP_S3_CLIP_BUCKET}/${thumbnail}`}
              />
              <StyledPlayButton />
              <ThumbnailBackground />
            </ThumbnailWrapper>
          )}
          <SlidingContent className={contentClass} $hasThumbnail={!!thumbnail}>
            <Text>{text}</Text>
            <StyledCtaButton>
              <span>{buttonText}</span>
              <MdLaunch />
            </StyledCtaButton>
          </SlidingContent>
        </StyledLink>
        <DefaultBorder sx={{ ...theme.borders["overlayDefault"] }}>
          <NotificationContainer
            onClick={togglePanel}
            className={hide ? "hide" : ""}
          >
            <StyledNotificationBell />
            <NotificationDot />
          </NotificationContainer>
        </DefaultBorder>
      </Wrapper>
    </Box>
  );
};
